import {ReactComponent as InstagramIcon} from './instagram.svg'

function Instagram() {
  return <InstagramIcon />
}

export default Instagram
